import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie"; // Import the js-cookie package

const Career = () => {
  const [jobs, setJobs] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
    career: null, // Field for career (job post)
  });
  const [formStatus, setFormStatus] = useState({
    loading: false,
    success: false,
    error: "",
  });

  // Fetching job listings from the API when the component mounts
  useEffect(() => {
    axios
      .get("https://mesoperations.com/api/api/career/")
      .then((response) => {
        setJobs(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }, []);

  // Handle input change for the form fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ ...formStatus, loading: true, error: "" });

    try {
      // Get the CSRF token from the cookie
      const csrfToken = Cookies.get("csrftoken");

      const response = await axios.post(
        "https://mesoperations.com/api/api/career-form/",
        formData,
        {
          headers: {
            "X-CSRFToken": csrfToken, // Include the CSRF token in the request headers
          },
        }
      );

      if (response.status === 201 || response.status === 200) {
        setFormStatus({ loading: false, success: true, error: "" });
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: "Your form has been sent successfully.",
          confirmButtonText: "OK",
        });
        // Clear form after successful submission
        setFormData({
          name: "",
          email: "",
          mobile: "",
          message: "",
          career: null,
        });
        setModalVisible(false); // Close modal
      }
    } catch (error) {
      setFormStatus({
        loading: false,
        success: false,
        error: "Failed to submit the form. Please try again.",
      });
    }
  };

  // Function to open the modal and set job details
  const openModal = (job) => {
    setFormData({
      name: "", // Reset form fields
      email: "",
      mobile: "",
      message: "",
      career: job.id, // Set the selected job post
    });
    setModalVisible(true);
  };

  return (
    <div>
      <div className="banner">
        <img src="assets/img/service.jpg" alt="Service" />
      </div>

      <section id="advertisers" className="advertisers-service-sec pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="section-header text-center">
              <h2 className="fw-bold fs-1">
                Apply
                <span className="b-class-secondary"> for </span> job
              </h2>
              <p className="sec-icon">
                <i className="fa-solid fa-gear"></i>
              </p>
            </div>
          </div>
          <div className="row mt-5 mt-md-4 row-cols-1 row-cols-sm-1 row-cols-md-3 justify-content-center">
            {jobs.length > 0 ? (
              jobs.map((job, index) => (
                <div className="col" key={index}>
                  <div className="service-card">
                    <div className="icon-wrapper">
                      <i className="fa-solid fa-briefcase"></i>
                    </div>
                    <p>
                      <strong>Post:</strong> {job.post}
                      <br />
                      <strong>Salary:</strong> {job.salary}
                      <br />
                      <strong>Qualification:</strong> {job.qualification}
                      <br />
                      <strong>Experience:</strong> {job.experience}
                    </p>
                    <button
                      className="btn btn-primary"
                      onClick={() => openModal(job)}
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center">
                No job listings available at the moment.
              </p>
            )}
          </div>
        </div>
      </section>

      {modalVisible && (
        <div className="modal fade show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Apply for Job</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalVisible(false)}
                ></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="mobile" className="form-label">
                      Mobile
                    </label>
                    <input
                      type="tel"
                      name="mobile"
                      className="form-control"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="message" className="form-label">
                      Message
                    </label>
                    <textarea
                      name="message"
                      className="form-control"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                    ></textarea>
                  </div>
                  {formStatus.loading && (
                    <div className="loading">Loading...</div>
                  )}
                  {formStatus.error && (
                    <div className="error-message">{formStatus.error}</div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setModalVisible(false)}
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={formStatus.loading}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {modalVisible && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default Career;
